import { useState, useEffect, useCallback } from 'react';
import api from '../../api';
import Layout from '../../components/Layout';
import stili from '../../components/competenze/stili';
import ConflittoVersione, { eConflitto } from '../../components/ConflittoVersione';
import { formattaEuro } from '../../utils/importi';

const RUOLI = { operatrice: 'Operatrice', professionista: 'Professionista' };

// Tariffe orarie per ruolo tariffario (solo admin): servono a suggerire l'importo dei lavori a ore
export default function TariffeOrarie() {
  const [tariffe, setTariffe] = useState([]);
  const [valori, setValori] = useState({});
  const [errore, setErrore] = useState('');
  const [messaggio, setMessaggio] = useState('');
  const [conflitto, setConflitto] = useState(null);

  const carica = useCallback(() => {
    api.get('/competenze/tariffe-orarie').then(r => {
      setTariffe(r.data);
      setValori(Object.fromEntries(r.data.map(t => [t.id, formattaEuro(t.tariffa)])));
    }).catch(err => setErrore(err.response?.data?.errore || 'Errore nel caricamento'));
  }, []);
  useEffect(() => { carica(); }, [carica]);

  const salva = async (t, version) => {
    setErrore('');
    setMessaggio('');
    try {
      await api.put(`/competenze/tariffe-orarie/${t.id}`, { tariffa: valori[t.id], version });
      setConflitto(null);
      setMessaggio(`Tariffa ${RUOLI[t.ruolo].toLowerCase()} salvata`);
      carica();
    } catch (err) {
      if (eConflitto(err)) setConflitto({ ...err.response.data, tariffa: t });
      else setErrore(err.response?.data?.errore || 'Salvataggio non riuscito');
    }
  };

  return (
    <Layout>
      <div style={stili.topBar}><h2 style={{ margin: 0 }}>Tariffe orarie</h2></div>
      <p style={{ color: '#555', fontSize: '0.88rem', marginTop: 0 }}>
        Una tariffa oraria (IVA esclusa) per ruolo tariffario. L'importo suggerito di un lavoro a ore è <strong>minuti ÷ 60 × tariffa</strong> del ruolo di chi ha svolto, arrotondato al centesimo.
        Il ruolo di ciascun utente si imposta in Utenti e permessi.
      </p>
      {errore && <div style={stili.errore}>{errore}</div>}
      {messaggio && <div style={{ background: '#ecfdf5', color: '#166534', padding: '0.6rem', borderRadius: '6px', marginBottom: '0.8rem', fontSize: '0.88rem' }}>{messaggio}</div>}
      <table style={{ ...stili.table, maxWidth: '520px' }}>
        <thead><tr><th style={stili.th}>Ruolo</th><th style={stili.th}>Tariffa oraria (€)</th><th style={stili.th}></th></tr></thead>
        <tbody>
          {tariffe.map(t => (
            <tr key={t.id} style={stili.tr}>
              <td style={stili.td}>{RUOLI[t.ruolo]}</td>
              <td style={stili.td}>
                <input value={valori[t.id] ?? ''} onChange={e => setValori(v => ({ ...v, [t.id]: e.target.value }))} inputMode="decimal" aria-label={`Tariffa ${RUOLI[t.ruolo]}`} style={{ ...stili.input, width: '110px' }} />
              </td>
              <td style={stili.td}><button onClick={() => salva(t, t.version)} style={stili.btn}>Salva</button></td>
            </tr>
          ))}
        </tbody>
      </table>
      {conflitto && (
        <ConflittoVersione conflitto={conflitto} onRicarica={() => { setConflitto(null); carica(); }} onSovrascrivi={() => salva(conflitto.tariffa, conflitto.attuale.version)} />
      )}
    </Layout>
  );
}
